export const LINKEDIN_ERROR_MESSAGE =
  'Please, enter the correct LinkedIn link. Example: www.linkedin.com/in/your-profile';
export const ADDITIONAL_LINK_ERROR_MESSAGE = 'Please, enter a correct URL';
export const INVALID_FORMAT_ERROR_MESSAGE = (extensions: string) =>
  `Please attach your file in the following format: ${extensions}`;
export const EMPTY_FILE_ERROR_MESSAGE =
  'Looks like your file has no data, please attach the correct one';
export const LARGE_FILE_ERROR_MESSAGE = 'Please attach PDF or DOC, 20 MB max';
